export default {
  YELLOW: 'yellow',
  BLUE: 'blue'
};


/** WEBPACK FOOTER **
 ** ./examples/03 Nesting/Drag Sources/Colors.js
 **/